module.exports = __webpack_public_path__ + "static/media/arties1.a47e9439.jpg";